function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a7a92418"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "tw-mb-5px"
};
var _hoisted_2 = {
  "class": "tw-flex"
};
var _hoisted_3 = ["href"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["href"];
var _hoisted_6 = ["src"];
var _hoisted_7 = ["href"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["href"];
var _hoisted_10 = {
  "class": "tw-size-[34px] tw-rounded-full tw-bg-w-primary tw-flex tw-items-center tw-justify-center tw-mr-20px"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  "class": "tw-flex tw-items-center"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  "class": "tw-flex tw-flex-col tw-justify-between tw-items-center tw-flex-wrap sm:tw-flex-nowrap"
};
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = ["innerHTML"];
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { useMetadataStore } from "@wkWebSrc/js/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'ShareModal',
  props: {
    showModal: {
      type: Boolean,
      "default": false
    },
    icons: {},
    labels: {},
    shareModalData: {},
    gaEvent: {}
  },
  emits: ["closedModal"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __emit = _ref.emit;
    var mdStore = useMetadataStore();
    /**
     * Precondition:
     * - This modal has to be used iff there is no default mechanism in the device the application is running
     * - This behaviour is intentional since this component will simply open a share modal, it won't handle the case in which there is another share mechanism
     * */
    var props = __props;
    var emits = __emit;
    var show = ref(false);
    var success = ref(null);
    var telegram = computed(function () {
      return "https://t.me/share/url?url=".concat(encodeURIComponent(props.shareModalData.url + "&utm_medium=telegram"), "&text=").concat(encodeURIComponent(props.shareModalData.title || ""));
    });
    var whatsapp = computed(function () {
      return "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(props.shareModalData.title + "\n" + props.shareModalData.url + "&utm_medium=whatsapp"));
    });
    var facebook = computed(function () {
      return "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(props.shareModalData.url + "&utm_medium=facebook"));
    });
    var email = computed(function () {
      // eslint-disable-next-line max-len
      return "mailto:?subject=".concat(props.shareModalData.title, "&body=").concat(encodeURIComponent(props.shareModalData.title + "\n\n" + props.shareModalData.url + "&utm_medium=email"));
    });
    onBeforeMount(function () {
      show.value = props.showModal;
      mdStore.setLocation("Modale Condivisione");
    });
    onBeforeUnmount(function () {
      mdStore.setLocation("");
    });
    var handleShareBtt = function handleShareBtt(type) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _props$shareModalData, url, title;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _props$shareModalData = props.shareModalData, url = _props$shareModalData.url, title = _props$shareModalData.title;
              if (!title) title = "";
              //Sending GA Event
              if (props.gaEvent) sendGAEvent(props.gaEvent, {
                event_location: "".concat(props.shareModalData.location, " - ").concat(mdStore.location),
                social: type
              });
              _context.t0 = type;
              _context.next = _context.t0 === "telegram" ? 6 : _context.t0 === "whatsapp" ? 8 : _context.t0 === "facebook" ? 10 : _context.t0 === "email" ? 12 : 14;
              break;
            case 6:
              url = "https://t.me/share/url?url=".concat(encodeURIComponent(url + "&utm_medium=telegram"), "&text=").concat(encodeURIComponent(title));
              return _context.abrupt("break", 15);
            case 8:
              url = "https://api.whatsapp.com/send?text=".concat(encodeURIComponent(title + "\n" + url + "&utm_medium=whatsapp"));
              return _context.abrupt("break", 15);
            case 10:
              url = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url + "&utm_medium=facebook"));
              return _context.abrupt("break", 15);
            case 12:
              window.location.href = "mailto:?subject=".concat(title, "&body=").concat(encodeURIComponent(title + "\n\n" + url + "&utm_medium=email"));
              return _context.abrupt("return");
            case 14:
              return _context.abrupt("break", 15);
            case 15:
              window.open(url, "_blank", "location=yes,height=350,width=600,scrollbars=yes,status=yes");
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    var handleCopyText = function handleCopyText() {
      try {
        navigator.clipboard.writeText(props.shareModalData.url);
        success.value = true;
      } catch (err) {
        console.error(err);
        success.value = false;
      } finally {
        //Removing the status text
        setTimeout(function () {
          success.value = null;
        }, 5000);
      }
    };
    var closedModal = function closedModal() {
      emits("closedModal");
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(BaseBtModal, {
        id: "share-modal",
        modelValue: show.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return show.value = $event;
        }),
        "data-cy": "share-modal",
        "show-modal": show.value,
        "custom-modal-dialog-classes": "modal-lg",
        "custom-modal-body-classes": "tw-py-15px",
        "header-title": _ctx.labels.share_ad,
        onClosed: closedModal
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.labels.share_on_social), 1 /* TEXT */), _createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
            id: "facebook-share",
            "data-cy": "facebook-share-btn",
            "class": "tw-flex tw-items-center tw-py-10px",
            href: facebook.value,
            onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
              return handleShareBtt('facebook');
            }, ["stop", "prevent"]))
          }, [_createElementVNode("img", {
            height: "40",
            width: "40",
            src: _ctx.icons.fb_rounded,
            "class": "share-social-icon tw-mr-20px",
            alt: "Icona Facebook"
          }, null, 8 /* PROPS */, _hoisted_4)], 8 /* PROPS */, _hoisted_3), _createElementVNode("a", {
            id: "whatsapp-share",
            "data-cy": "whatsapp-share-btn",
            "class": "tw-flex tw-items-center tw-py-10px",
            href: whatsapp.value,
            onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
              return handleShareBtt('whatsapp');
            }, ["stop", "prevent"]))
          }, [_createElementVNode("img", {
            height: "40",
            width: "40",
            src: _ctx.icons.whatsapp_rounded,
            "class": "share-social-icon tw-mr-20px",
            alt: "Icona WhatsApp"
          }, null, 8 /* PROPS */, _hoisted_6)], 8 /* PROPS */, _hoisted_5), _createElementVNode("a", {
            id: "telegram-share",
            "data-cy": "telegram-share-btn",
            "class": "tw-flex tw-items-center tw-py-10px",
            href: telegram.value,
            onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
              return handleShareBtt('telegram');
            }, ["stop", "prevent"]))
          }, [_createElementVNode("img", {
            height: "40",
            width: "40",
            src: _ctx.icons.telegram_rounded,
            "class": "share-social-icon tw-mr-20px",
            alt: "Icona Telegram"
          }, null, 8 /* PROPS */, _hoisted_8)], 8 /* PROPS */, _hoisted_7), _createElementVNode("a", {
            "data-cy": "email-share-btn",
            "class": "tw-flex tw-items-center tw-py-10px",
            href: email.value,
            onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
              return handleShareBtt('email');
            }, ["prevent", "stop"]))
          }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
            width: "28",
            src: _ctx.icons.mail,
            "class": "share-social-icon",
            alt: "Icona Email"
          }, null, 8 /* PROPS */, _hoisted_11)])], 8 /* PROPS */, _hoisted_9)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
            "class": "tw-mb-5px",
            innerHTML: _ctx.labels.generic_or
          }, null, 8 /* PROPS */, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createVNode(BaseInput, {
            "class": "tw-mr-0 sm:tw-mr-10px",
            type: "text",
            size: "45",
            disabled: "",
            "model-value": _ctx.shareModalData.url
          }, null, 8 /* PROPS */, ["model-value"]), _createVNode(BaseButton, {
            "class": "tw-btn-w-primary tw-relative tw-mt-10px",
            onClick: _withModifiers(handleCopyText, ["stop"])
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("span", {
                innerHTML: _ctx.labels.generic_copy
              }, null, 8 /* PROPS */, _hoisted_15), success.value !== null ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                "class": "-gray popup-copied-link tw-w-full tw-absolute tw-text-10",
                innerHTML: success.value ? _ctx.labels.copied_link : _ctx.labels.copied_error
              }, null, 8 /* PROPS */, _hoisted_16)) : _createCommentVNode("v-if", true)];
            }),
            _: 1 /* STABLE */
          })])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "show-modal", "header-title"]);
    };
  }
});